import React from 'react'
import Image from 'next/image'

interface Props {
    image: any,
    bg?: string,
    info: {
        id: number
        name: string
        photo: string
        photo_minify: string
        position: number
        post: string
        email?: string
    },
    styles?: string
}

const PersonAvatar: React.FC<any> = ({ bg, image, info, styles }) => {
    return (
        <div className="news-details__person">
            <div style={bg ? { background: bg } : {}} className="news-details__person-img">
                <Image className={styles} src={image} width={164} height={186} alt='person' />
            </div>
            <p className="news-details__person-name">{info.name}, <br />{info.post}{info?.email ? <>,<br/></> : ''}{info?.email ? <a style={{color: 'currentcolor'}} href={`mailto:${info.email}`}>{info.email}</a> : ''}</p>
        </div>
    )
}

export default PersonAvatar
